import { ConfigBlockState } from '../WidgetBlocks/types/IWidgetBlock';

export type IMigrationScript<S extends ConfigBlockState, T = S> = (state: S) => T;

export default <T extends ConfigBlockState>(migrationScripts: IMigrationScript<T>[]): IMigrationScript<T> =>
    (state) =>
        migrationScripts.reduce((enhancedState, migrationScript, index) => {
            if ((typeof enhancedState.version === 'undefined' && index === 0) || parseInt(`${enhancedState.version}`) === index) {
                const newState = migrationScript(enhancedState);

                return { ...newState, version: index + 1 };
            } else {
                return enhancedState;
            }
        }, state);
